// Generated by @sgflabs/opticomm-sdk-codegen. Do not edit.
// Run `yarn workspace @sgflabs/opticomm-sdk-codegen generate` after changing a backend route.
export const createVendorTryOn = (client) => ({
    /**
     * `GET /vendor/try-on/settings`
     *
     * @operationId VendorTryOnSettingsGet
     * @source apps/backend/src/api/vendor/try-on/settings/route.ts
     */
    getSettings: (query, headers) => client.fetch("/vendor/try-on/settings", { method: "GET", query, headers }),
    /**
     * `GET /vendor/try-on/usage`
     *
     * @operationId VendorTryOnUsageList
     * @source apps/backend/src/api/vendor/try-on/usage/route.ts
     */
    listUsage: (query, headers) => client.fetch("/vendor/try-on/usage", { method: "GET", query, headers }),
});
//# sourceMappingURL=try-on.js.map